import { Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject } from 'rxjs';
import { take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { TagViewModel } from '../../models/view-models/tag-models/tag-view.model';
import { ScreensStateService } from './screens-state.service';
import { TagService } from '../http-services/tag.service';
import { UIService } from '../utils/ui.service';
import { MonitorHub } from '../../../shared-module/hubs/monitor.hub';

@Injectable()
export class TagsStateService {
  public tagSelectionChanged = new BehaviorSubject<TagViewModel>(null);

  constructor(
    public tagService: TagService,
    public monitorHub: MonitorHub,
    public screenStateService: ScreensStateService,
    public toastrService: ToastrService,
    public uiService: UIService
  ) {
    this.tagService.getAllTagsInfo();

    this.monitorHub.TagsUpdated
      .pipe(takeUntilDestroyed())
      .subscribe(data => this.tagService.tagCollectionChanged.next(data));
  }

  public changeTag(tagModel: TagViewModel) {
    this.synchTags(tagModel);
    this.tagSelectionChanged.next(tagModel);
  }

  public synchTags(tagModel: TagViewModel) {
    if (tagModel) {
      if (
        this.screenStateService._selectedScreens &&
        this.screenStateService._selectedScreens.length
      ) {
        this.screenStateService.updateTagAssignments(tagModel).pipe(
          take(1)
        ).subscribe();
      } else {
        this.uiService.showBottomPanel();
        this.toastrService.info(
          'You should select at least one screen to assign a tag',
          'Tag assignment info'
        );
      }
      this.tagSelectionChanged.next(tagModel);
    } else {
      this.tagSelectionChanged.next(null);
    }
  }
}
